import React from 'react'
import { COLOR_TOMATO } from '../../constants'

export default function LoadingAbsolute() {
    return (
        <div style={{ position: 'absolute', zIndex: 9999, top: 0, left: 0, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', width: '100%', height: '100vh' }}>
            <img style={{ width: 180 }} src="https://cdn-images-1.medium.com/max/1600/1*QHTfTrNDMazdIE_KFwpMyA.gif" alt='loading-animation' />
            <h3 style={{fontWeight:'bold', color: COLOR_TOMATO}}>ກຳລັງໂຫລດຂໍ້ມູນ...</h3>
        </div>
    )
}
